var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"panelBlock map-widget businesses-map"},[_c('v-flex',{staticClass:"ypoMap"},[_c('ypo-map',{attrs:{"mapList":_vm.mapList,"centerTo":_vm.centerTo}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }